import inspectAPI from '@/services/api/inventory/inspect/index.js'

const state = {
	list: null,
	count: null,
	ingCount: 0,
	failCount: 0,
	loadParams: {
		order: ['CREATE_DATETIME'],
		orderDirection: ['DESC'],
		status: ['ING'],
		offset: 0,
		length: 50,
	},
}

const getters = {
	status: state => state.loadParams.status[0],
	count: state => state.count,
	list: state => state.list,
	ingCount: state => state.ingCount,
	failCount: state => state.failCount,
}

const mutations = {
	setList: (state, data) => {
		state.list = [...state.list, ...data.list]
		state.count = data.count
		state.loadParams.offset = state.list.length
		if (state.loadParams.status[0] == 'ING') state.ingCount = data.count
		else state.failCount = data.count
	},
	setLoadParams: (state, loadParams) => {
		if (loadParams != null)
			Object.keys(loadParams).forEach(key => {
				state.loadParams[key] = loadParams[key]
			})
	},
	setCount: (state, count) => {
		state.count = count
	},
	setStatusCount: (state, count) => {
		const { ingCount, failCount } = count
		state.ingCount = ingCount ?? 0
		state.failCount = failCount ?? 0
	},
	initOffset: state => {
		state.loadParams.offset = 0
		state.list = []
	},
}

const actions = {
	getList: async ({ commit, rootGetters, state }, isMore = false) => {
		if (!isMore) commit('initOffset')
		const response = await inspectAPI.lookupList(
			rootGetters.instituteId,
			state.loadParams
		)
		commit('setList', response.data)
	},
	getCount: async ({ commit, rootGetters }) => {
		const response = await inspectAPI.lookupList(rootGetters.instituteId, {
			offset: 0,
			length: 0,
			status: ['ING'],
		})
		commit('setCount', response.data.count)
	},
	getStatusCount: async ({ commit, rootGetters }) => {
		const response = await inspectAPI.lookupList(rootGetters.instituteId, {
			offset: 0,
			length: 0,
			status: ['ING'],
		})
		const response2 = await inspectAPI.lookupList(rootGetters.instituteId, {
			offset: 0,
			length: 0,
			status: ['FAIL'],
		})
		const ingCount = response.data.count
		const failCount = response2.data.count
		commit('setStatusCount', { ingCount, failCount })
	},
	setLoadParams: async ({ commit, dispatch }, loadParams) => {
		commit('setLoadParams', loadParams)
		dispatch('getList')
	},
	deleteItem: async ({ rootGetters }, ids) => {
		return await inspectAPI.deleteItem(rootGetters.instituteId, {
			ids: ids,
		})
	},
}

export default { namespaced: true, state, getters, mutations, actions }
